import { render, staticRenderFns } from "./SurgicalCasesCard.vue?vue&type=template&id=387263ec&scoped=true&"
import script from "./SurgicalCasesCard.vue?vue&type=script&lang=js&"
export * from "./SurgicalCasesCard.vue?vue&type=script&lang=js&"
import style0 from "./SurgicalCasesCard.vue?vue&type=style&index=0&id=387263ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387263ec",
  null
  
)

export default component.exports